<script setup lang="ts">
import { useAddressSystemStore } from '@/store/addressSystem'
import { useBasketStore } from '@/store/basket/basket'
import { useUserStore } from '@/store/user/user'

import HeaderDeliveryWidget from '@/components/Header/HeaderDeliveryWidget.vue'

const addressSystemStore = useAddressSystemStore()
const basketStore = useBasketStore()
const userStore = useUserStore()

const isLoading = ref(true)

const currentBasketAddress = computed(() => {
  return userStore.isAuthenticated
    ? basketStore.data.delivery.order_address
    : addressSystemStore.deliveryWidget.order_address
})

const componentClasses = computed(() => {
  return [
    'header-mobile-bottom',
    {
      'header-mobile-bottom--sticky':
        !currentBasketAddress.value && !isLoading.value,
    },
  ]
})

watch(
  () => currentBasketAddress.value,
  (address) => setCSSProperty(address),
)

const setCSSProperty = (value?: string | null) => {
  const position = value ? '0px' : '72px'

  document.documentElement.style.setProperty(
    '--header-mobile-position',
    position,
  )
}

onMounted(() => {
  isLoading.value = false

  setCSSProperty(currentBasketAddress.value)
})
</script>

<template>
  <div :class="componentClasses">
    <header-delivery-widget />
  </div>
</template>

<style scoped lang="scss">
.header-mobile-bottom {
  padding: 16px 20px 15px;
  background-color: var(--ui-color-white);
  border-bottom: 1px solid var(--ui-color-sandy-200);

  &--sticky {
    position: sticky;
    top: 0;
    z-index: 1005;
  }
}
</style>
